import { useCurrentPostHelpers } from "@circle-react/components/PostsV3/useCurrentPostHelpers";
import { useCurrentPostContext } from "@circle-react/contexts/currentPostContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";
import { useRouteHelpers } from "@/react/routes/Main/useRouteHelpers";

interface PostContentWrapperProps {
  children: React.ReactNode;
}

export const PostContentWrapper = ({ children }: PostContentWrapperProps) => {
  const {
    isImagePost,
    isPostBodyEmpty,
    isPostMetaHidden,
    isSharedPostWithTeaserLayout,
  } = useCurrentPostHelpers();
  const { usedIn } = useCurrentPostContext();
  const { isFeedRoute } = useRouteHelpers();
  const isUsedInFullPostModal = usedIn === "full-post-modal";

  const shouldAddBottomPaddingForPostsWithEmptyBody =
    isPostBodyEmpty && !isFeedRoute && !isPostMetaHidden && !isImagePost;

  return (
    <div
      className={classNames(anchorClassNames("post__content"), "text-dark", {
        "px-4 py-3 md:p-5 md:px-6": !isImagePost && isPostMetaHidden,
        "px-4 py-3 md:px-6 md:py-5": !isImagePost && !isPostMetaHidden,
        "pt-3 md:pt-5":
          isImagePost && !isUsedInFullPostModal && isPostMetaHidden,
        "lg:pt-5": isImagePost && !isUsedInFullPostModal && !isPostMetaHidden,
        "py-5": isImagePost && isUsedInFullPostModal,
        "!pb-0": isImagePost && isUsedInFullPostModal && !isPostBodyEmpty,
        "pb-5": shouldAddBottomPaddingForPostsWithEmptyBody,
        relative: isSharedPostWithTeaserLayout,
      })}
      data-testid="post-content-wrapper"
    >
      {children}
    </div>
  );
};
